/* eslint @typescript-eslint/no-var-requires: "off" */
import * as api from "../../constant/NewAPI";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Utils from "../../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";


// const api = require("../../constant/API");

const Physiotherapist = () => {

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState("");
    const [physioTherapistList, setPhysioTherapistList] = useState([]);
    const [institutionList, setInstitutionList] = useState([]);
    const [therapistList, setTherapistList] = useState([]);
    const [instId, setInstId] = useState("");
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        getPhysioList();
        getTherapistList();
        if (roleId == '1') {
            getInstitutionList();
        }
    }, [])

    function getPhysioList() {
        const getPhysioLst = api.GetPsychotherapistList //+ "?userId=" + userId + "&roleId=" + roleId;
        fetch(getPhysioLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.error == true) {
                    if (lstResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (lstResult.data != null) {
                        setPhysioTherapistList(lstResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the nutritionist list", error)
            })
    }

    function getInstitutionList() {
        const getInstList = api.PsychotherapistInstitutionList + '/' + roleId //+ "?userId=" + userId + "&roleId=" + roleId;
        fetch(getInstList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((insResponse) => insResponse.json())
            .then((insResult) => {
                if (insResult.error == true) {
                    if (insResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (insResult.data != null) {
                        setInstitutionList(insResult.data)
                    }
                }
            })
    }

    function getTherapistList() {
        const getphysio = api.GetTherapist;
        fetch(getphysio, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((therapistResponse) => therapistResponse.json())
            .then((therapistResult) => {
                if (therapistResult.error == true) {
                    if (therapistResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (therapistResult.data != null) {
                        setTherapistList(therapistResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the physiotherapist list", error);
            })
    }

    function savePhysioTherapist() {
        // console.log("Saved Physiotherapist");
        alert("Coming Soon..!");
    }

    const filteredData = physioTherapistList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const instituteRender = (rowData) => {
        return <span>{rowData.InstitutionName}</span>
    }

    const therapistRender = (rowData) => {
        return <span>{rowData.PhysiotherapistName}</span>
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {(roleId == 1 || roleId == 5) ? (
                                            <>
                                                <div className="row col-lg-6 court-sortby sortbyset">
                                                    <div className="col-lg-6 col-sm-6">
                                                        <Link
                                                            className="btn btn-secondary"
                                                            to="#"
                                                            onClick={() => setOpenModal(true)}
                                                        >
                                                            <i className="fas fa-user-clock" />&nbsp;
                                                            Assign Physiotherapist
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="InstitutionName"
                                                    body={instituteRender}
                                                    header="Institute"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="PhysiotherapistName"
                                                    header="Physiotherapist"
                                                    body={therapistRender}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Assign Physiotherapist Modal */}

            <div
                className="modal custom-modal fade payment-modal"
                id="assign-physiotherapist"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    <i className="fas fa-user-clock" />&nbsp;
                                    Assign Physiotherapist
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="col-lg-12">
                                    <div className="input-space">
                                        <label className="form-label">Institute</label>
                                        <Select
                                            required
                                            value={institutionList.find(ins => ins.institutionId === instId) ? {
                                                value: instId,
                                                label: institutionList.find(ins => ins.institutionId === instId).institutionName
                                            } : null}
                                            onChange={(e) => {
                                                setInstId(e.value);
                                            }}
                                            placeholder="Select Institute"
                                            options={institutionList.map(ins => ({
                                                value: ins.institutionId,
                                                label: ins.institutionName
                                            }))}
                                        >
                                        </Select>
                                    </div>
                                    {/* {error && <div className="alert alert-danger">{error}</div>} */}
                                </div>
                                <div className="col-lg-12">
                                    <div className="input-space">
                                        <label className="form-label">Physiotherapist</label>
                                        <Select
                                            required
                                            placeholder="Select Physiotherapist">

                                        </Select>
                                    </div>
                                    {/* {nameError && <div className="alert alert-danger">{nameError}</div>} */}
                                </div>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <div className="table-accept-btn">
                                <Link to="#" className="btn btn-primary close" onClick={savePhysioTherapist} data-bs-dismiss="modal" aria-label="Close">
                                    Submit
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                size="md"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case"><i className="fas fa-user-check" />Assign Physiotherapist</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <div className="col-lg-12">
                        <div className="input-space">
                            <label className="form-label">Institute</label>
                            <Select
                                required
                                value={institutionList.find(ins => ins.institutionId === instId) ? {
                                    value: instId,
                                    label: institutionList.find(ins => ins.institutionId === instId).institutionName
                                } : null}
                                onChange={(e) => {
                                    setInstId(e.value);
                                }}
                                placeholder="Select Institute"
                                options={institutionList.map(ins => ({
                                    value: ins.institutionId,
                                    label: ins.institutionName
                                }))}
                            >
                            </Select>
                        </div>
                        {/* {error && <div className="alert alert-danger">{error}</div>} */}
                    </div>
                    <div className="col-lg-12">
                        <div className="input-space">
                            <label className="form-label">Physiotherapist</label>
                            <Select
                                required
                                placeholder="Select Physiotherapist">

                            </Select>
                        </div>
                        {/* {nameError && <div className="alert alert-danger">{nameError}</div>} */}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        onClick={() => { savePhysioTherapist(); setOpenModal(false) }}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" />Save</b>
                    </Button>
                </ModalFooter>
            </Modal>

            {/* /Assign Physiotherapist Modal */}
        </>
    );
}

export default Physiotherapist;